var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBggg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 584,
    viewBox: "0 0 1440 584",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_153_4542)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1443,
    height: 584,
    transform: "translate(-2)",
    fill: "url(#paint0_radial_153_4542)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_153_4542)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -404,
    y: -4,
    width: 2248,
    height: 1178.5,
    rx: 36.3313,
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_153_4542)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -82.8572,
    y: -4,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1904,
    y: -4,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.238,
    y: -4,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.286,
    y: -4,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.333,
    y: -4,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.381,
    y: -4,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 559.428,
    y: -4,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.477,
    y: -4,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.523,
    y: -4,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880.572,
    y: -4,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 987.619,
    y: -4,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1094.67,
    y: -4,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1201.71,
    y: -4,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1308.76,
    y: -4,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1415.81,
    y: -4,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: -82.8572,
    y: 103.047,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1904,
    y: 103.047,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.238,
    y: 103.047,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.286,
    y: 103.047,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.333,
    y: 103.047,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.381,
    y: 103.047,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 559.428,
    y: 103.047,
    width: 107.048,
    height: 107.048,
    fill: "white",
    fillOpacity: 0.12,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.477,
    y: 103.047,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.523,
    y: 103.047,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880.572,
    y: 103.047,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 987.619,
    y: 103.047,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1094.67,
    y: 103.047,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1201.71,
    y: 103.047,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1308.76,
    y: 103.047,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1415.81,
    y: 103.047,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: -82.8572,
    y: 210.094,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1904,
    y: 210.094,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.238,
    y: 210.094,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.286,
    y: 210.094,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.333,
    y: 210.094,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.381,
    y: 210.094,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 559.428,
    y: 210.094,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.477,
    y: 210.094,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.523,
    y: 210.094,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880.572,
    y: 210.094,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 987.619,
    y: 210.094,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1094.67,
    y: 210.094,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1201.71,
    y: 210.094,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1308.76,
    y: 210.094,
    width: 107.048,
    height: 107.048,
    fill: "white",
    fillOpacity: 0.12,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1415.81,
    y: 210.094,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: -82.8572,
    y: 317.141,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1904,
    y: 317.141,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.238,
    y: 317.141,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.286,
    y: 317.141,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.333,
    y: 317.141,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.381,
    y: 317.141,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 559.428,
    y: 317.141,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.477,
    y: 317.141,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.523,
    y: 317.141,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880.572,
    y: 317.141,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 987.619,
    y: 317.141,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1094.67,
    y: 317.141,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1201.71,
    y: 317.141,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1308.76,
    y: 317.141,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1415.81,
    y: 317.141,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: -82.8572,
    y: 424.188,
    width: 107.048,
    height: 107.048,
    fill: "white",
    fillOpacity: 0.12,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1904,
    y: 424.188,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.238,
    y: 424.187,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.286,
    y: 424.188,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.333,
    y: 424.187,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.381,
    y: 424.188,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 559.428,
    y: 424.187,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.477,
    y: 424.187,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.523,
    y: 424.187,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880.572,
    y: 424.187,
    width: 107.048,
    height: 107.048,
    fill: "white",
    fillOpacity: 0.12,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 987.619,
    y: 424.188,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1094.67,
    y: 424.187,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1201.71,
    y: 424.188,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1308.76,
    y: 424.187,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1415.81,
    y: 424.187,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: -82.8572,
    y: 531.234,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1904,
    y: 531.234,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.238,
    y: 531.234,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.286,
    y: 531.234,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.333,
    y: 531.234,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.381,
    y: 531.234,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 559.428,
    y: 531.234,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.477,
    y: 531.234,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.523,
    y: 531.234,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880.572,
    y: 531.234,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 987.619,
    y: 531.234,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1094.67,
    y: 531.234,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1201.71,
    y: 531.234,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1308.76,
    y: 531.234,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1415.81,
    y: 531.234,
    width: 107.048,
    height: 107.048,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 2.14095
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_153_4542",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(734.5 292) rotate(87.0563) scale(447.872 1105.21)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#174578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#112648"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_153_4542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1443,
    height: 584,
    fill: "white",
    transform: "translate(-2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_153_4542"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -404,
    y: -4,
    width: 2248,
    height: 1178.5,
    rx: 36.3313,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_153_4542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2248,
    height: 1438.72,
    fill: "white",
    transform: "translate(-404 -4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBggg);
export default __webpack_public_path__ + "static/media/bggg.e3d7f8df87fa74d3463e5a89f20d3b8a.svg";
export { ForwardRef as ReactComponent };